import React, {ReactElement, useState} from "react";
import {StyledBoxColumn} from "./StyledComponents";
import {PAGE_FRAGMENT_HALF_WIDTH, PD_XLG2} from "./dimens";
import {Button} from "@mui/material";
import {PasskeyInput} from "./PasskeyInput";
import {FormGenContentItem, FormGenLayoutSource} from "./FormGenContainer";

export function FormGenPasskey(props: {
  contentItem: FormGenContentItem,
  index: number,
  source: FormGenLayoutSource,
}): ReactElement {
  const value = props.source.getValue(props.contentItem);
  const config = props.contentItem.metadata.passkeyConfig || {length: 4, type: "numeric"};
  const [passkeyChanged, setPasskeyChanged] = useState<boolean>(false);
  const [passkey, setPasskey] = useState<string>(value);
  return <StyledBoxColumn style={{minWidth: PAGE_FRAGMENT_HALF_WIDTH, alignItems: "flex-start"}}>
    <StyledBoxColumn style={{alignItems: "center"}}>
      <PasskeyInput
        config={config}
        onPasskeyInputChanged={passkey => {
          setPasskey(passkey);
          setPasskeyChanged(true);
        }}
      />
    </StyledBoxColumn>
    <Button
      onClick={() => {
        props.source.setValue(props.contentItem, passkey);
        setPasskeyChanged(false);
      }}
      variant={"contained"} disabled={!passkeyChanged || passkey.length !== config.length}>Set</Button>
  </StyledBoxColumn>;
}